import React, {useState, useEffect} from "react";
import '../css/Xbar.css';
import {useNavigate} from "react-router-dom";
import { ORDER_MODES, setOrderMode } from '../utils/orderMode';


function XBar({activeItem, onItemClick}) {
    const navigate = useNavigate();
    const itemRoutes = {
        0: '/delivery',
        1: '/locations',
        2: '/menu',
        3: '/profile',
        9: '/home'
    };

    const isFastDeliveryHost = () => {
        if (typeof window === 'undefined') return false;
        return /(^|\.)fastdelivery\.ge$/i.test(window.location.hostname);
    };

    const handleItemClick = (index) => {
        if (isFastDeliveryHost() && index === 0) {
            setOrderMode(ORDER_MODES.DELIVERY);
        }

        // If clicking on menu and we have a selected company, navigate to it
        if (index === 2) {
            const savedCompany = localStorage.getItem('selectedCompany');
            navigate(savedCompany ? `/${savedCompany.toLowerCase()}` : itemRoutes[index]);
        } else if (itemRoutes[index]) {
            navigate(itemRoutes[index]);
        }
        onItemClick(index);
    };

    useEffect(() => {
        localStorage.setItem("activeItem", activeItem);
    }, [activeItem]);

    const [totalUnreadCount] = useState(0);



    const renderXBarItems = () => {
        const xbarItems = [
            {
                id: 0,
                label: 'Delivery',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon"
                         width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                         fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1" />
                        <path d="M6 9l3 0" />
                    </svg>
                )
            },
            {
                id: 1,
                label: 'Map',
                icon: (
                    <div className={"msg_containera"}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                             height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                             strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                            <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                        </svg>
                        {totalUnreadCount !== "" && totalUnreadCount !== null && totalUnreadCount !== 0 && (
                            <div className={"msg_item"}>
                                {totalUnreadCount}
                            </div>
                        )}
                    </div>
                )
            },
            {
                id: 9,
                label: 'Home',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon"
                         width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                         fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                        <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                        <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                    </svg>
                )
            },
            {
                id: 2,
                label: 'Menu',
                icon: (
                    <div className={"SMS_ICO"}>
                        <div className={"circle active"} id={"CIRClE"}>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon"
                             width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                             fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <rect className="cls-1" width="24" height="24"/>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3" />
                        </svg>
                    </div>
                )
            },
            {
                id: 3,
                label: 'Profile',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24"
                         height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                         strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                    </svg>
                )
            }
        ];

        return xbarItems.map((item) => (
            <div
                key={item.id}
                role="button"
                tabIndex={0}
                className={`xbar_item ${item.id === activeItem ? "active" : ""}`}
                onClick={() => handleItemClick(item.id)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleItemClick(item.id);
                    }
                }}
            >
                {item.icon}
                <span className="xbar_item_label">{item.label}</span>
            </div>
        ));
    };
    return (
        <div className={"xbar"}>



            <div className={"xbar_container"}>
                <div className={"xbar_items"}>
                    {renderXBarItems()}
                </div>
            </div>
        </div>


    );
}

export default XBar;
